import { wpAPI_ENDPOINTS, BMC_GET_DOCTORS_BY_SPECIALTY_PREFIX } from "../constants/apiConfig";
import {
  makeRequestForBmcGetAllSpecialties,
  makeRequestForDoctorWP,
  makeRequestForWP,
} from "../middleware/axiosForWordpress";
const lang = localStorage.getItem("lang") ?? "en";

export const finddoctorservice = {
  searchDoctor,
  getLocations,
  getAllDoctors,
  getDoctorByCondition,
  getDoctorByLocation,
  getallspecialties,
  getallspecialtiesByLocation,
  getDoctorProfile,
};

async function searchDoctor(searchString: string) {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.FIND_DOC +
    searchString +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForDoctorWP(options);
}

async function getAllDoctors(data: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_ALL_DOCTOR +
    data.id +
    "&cat_type=" +
    data.cat_type +
    "&vblog=" +
    data.vblog +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForDoctorWP(options);
}

async function getLocations() {
  const lang = localStorage.getItem("lang") ?? "en";
  const apiPath =
    wpAPI_ENDPOINTS.GET_LOCATIONS + `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  return await makeRequestForWP(options);
}

/** `getAllDoctersByLocation` vs BMC `getdoctorsbyspecialty`; same `vblog` / `id` query. */
function doctorsByLocationPath(
  data: { vblog: any; id: any },
  lang: string
): { apiPath: string; useBmcMobileApi: boolean } {
  const brand = (localStorage.getItem("brandName") || "").toLowerCase().trim();
  const ar = lang === "ar" ? "&lang=ar" : "";
  if (brand === "bmc") {
    return {
      apiPath:
        BMC_GET_DOCTORS_BY_SPECIALTY_PREFIX +
        data.vblog +
        "&id=" +
        data.id +
        ar,
      useBmcMobileApi: true,
    };
  }
  return {
    apiPath:
      wpAPI_ENDPOINTS.GET_DOC_BY_LOCATION +
      data.vblog +
      "&id=" +
      data.id +
      ar,
    useBmcMobileApi: false,
  };
}

async function getDoctorByCondition(data: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const { apiPath, useBmcMobileApi } = doctorsByLocationPath(data, lang);
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  if (useBmcMobileApi) {
    return await makeRequestForBmcGetAllSpecialties(options);
  }
  return await makeRequestForDoctorWP(options);
}

async function getDoctorByLocation(data: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const { apiPath, useBmcMobileApi } = doctorsByLocationPath(data, lang);
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  if (useBmcMobileApi) {
    return await makeRequestForBmcGetAllSpecialties(options);
  }
  return await makeRequestForDoctorWP(options);
}

async function getallspecialties() {
  const lang = localStorage.getItem("lang") ?? "en";
  const brand = (localStorage.getItem("brandName") || "").toLowerCase().trim();
  const apiPath =
    wpAPI_ENDPOINTS.GET_ALL_SPECIALITIES +
    `${lang === "ar" ? "?lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  if (brand === "bmc") {
    return await makeRequestForBmcGetAllSpecialties(options);
  }
  return await makeRequestForWP(options);
}

async function getallspecialtiesByLocation(vblog: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const brand = (localStorage.getItem("brandName") || "").toLowerCase().trim();
  const apiPathNoVblog =
    wpAPI_ENDPOINTS.GET_ALL_SPECIALITIES +
    `${lang === "ar" ? "?lang=ar" : ""}`;
  const apiPathWithVblog =
    wpAPI_ENDPOINTS.GET_ALL_SPECIALITIES_BY_LOCATION +
    vblog +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const apiPath = brand === "bmc" ? apiPathNoVblog : apiPathWithVblog;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  if (brand === "bmc") {
    return await makeRequestForBmcGetAllSpecialties(options);
  }
  return await makeRequestForWP(options);
}

async function getDoctorProfile(data: any) {
  const lang = localStorage.getItem("lang") ?? "en";
  const brand = (localStorage.getItem("brandName") || "").toLowerCase().trim();
  const vblog = brand === "bmc" ? "" : data.vblog;
  const apiPath =
    wpAPI_ENDPOINTS.GET_DOCTOR_PROFILE +
    vblog +
    "&id=" +
    data.id +
    `${lang === "ar" ? "&lang=ar" : ""}`;
  const options = {
    path: apiPath,
    method: "GET",
    customHeaders: {
      "Content-Type": "application/json",
    },
  };
  if (brand === "bmc") {
    return await makeRequestForBmcGetAllSpecialties(options);
  }
  return await makeRequestForDoctorWP(options);
}
